import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioClientComponent } from './inicio-client/inicio-client.component';
import { CuentaComponent } from './cuenta/cuenta.component';
import { AgendarCitaComponent } from './agendar-cita/agendar-cita.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: InicioClientComponent
  },
  {
    path: 'appointment-management',
    loadChildren: () => import('./gestion-citas/gestion-citas.module').then(m => m.GestionCitasModule)
  },
  {
    path: 'account',
    component: CuentaComponent
  },
  {
    path: 'schedule-appointment',
    component: AgendarCitaComponent
  },
   {
    path: 'schedule-appointment/:id',
    component: AgendarCitaComponent
  },
  {
    path: 'radar-mascotas',
    loadChildren: () =>
      import('./radar-mascotas/radar-mascotas.module').then(m => m.RadarMascotasModule)
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesClientRoutingModule { }
